import React, { Component } from "react";
import { observer } from "mobx-react";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import InfiniteScroll from "react-infinite-scroll-component";
import { Col, Row, Button, Label, Container } from "reactstrap";
import { buscaFiltrarVazio } from '../../../../utils/mensagens';
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";
import LoadingImage from "../../../comum/components/LoadingImage";
import Card from "../../../comum/components/Card";
import InputFiltro from '../../../comum/components/InputFiltro';
import {formatarDataCustomHTMLSemHora, numericSortFunc, dataSortFunc, situacaoFormatter, splitQuebraLinha} from '../../../../utils/formatar';
import { getMesTexto } from "../../../../utils/functions";

@observer
export class CardInformacaoDados extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        window.addEventListener('scroll', HeaderTableFixed)
    }

    componentDidMount() {
     
    }

     situacaoFormatter = (cell, row) => {
        if (!cell) return null;
    
        let classe = cell.toLowerCase().replace(/\s|\./g, '-');
        classe = classe.replace('--', '-');
        if (cell.toLowerCase() === "fora do terminal") {
            cell = "Fora term."
        }
    
        return <div className={`situacao-btn ${classe + ' pixMaior'}`}>{cell}</div>;
    
    };


    data = (data) => { 
        if (data === null) return "---";
        let dataFormatada;
        if (data) {
            let parsedData = new Date(data);
    
            if (!isNaN(parsedData)) {
                let d = parsedData.getDate();
                if (d < 10) d = "0" + d;
    
                let m = getMesTexto(parsedData.getMonth() + 1);
                console.log('data', d, m,  parsedData.getFullYear())
                dataFormatada = d+"/"+m+"/"+parsedData.getFullYear();
            }
        }
        
        console.log('data formatada', dataFormatada);
        return dataFormatada;
        
    }

    render() {
        console.log('Veiculos', this.controller.veiculos)
        return (

            this.controller.veiculos.map((item) => {
                console.log(item)
                return ( <div fluid>
                        <div className="card distanceFont"> 
                            <div className="filtros">
                                <Row className="align-items-end">
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                    <Label className="card-Item-alling font-st">Tipo:</Label>
                                </Col>
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                    <Label className="card-Item-alling ">{item.DscTipo}</Label>
                                </Col>
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                    <Label className="card-Item-alling font-st">Data e Hora:</Label>
                                </Col>
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                    <Label className="card-Item-alling">{this.data(item.Data) + " - " + item.Hora + ":00"}</Label>
                                </Col>
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                <Label className="card-Item-alling font-st">Placa:</Label>
                                </Col>
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                    <Label className="card-Item-alling ">{ item.Placa}</Label>
                                </Col>  <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                    <Label className="card-Item-alling font-st">Armador:</Label>
                                </Col>
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                    <Label className="card-Item-alling ">{item.ApelidoArmador}</Label>
                                </Col>
                                {item.TipoAgendId != 286 ? <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                    <Label className="card-Item-alling font-st">Booking:</Label>
                                </Col> : ""}
                                {item.TipoAgendId != 286 ? <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                    <Label className="card-Item-alling ">{ item.LstBookings}</Label>
                                </Col> : ""}  {item.TipoAgendId == 286 ? <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                    <Label className="card-Item-alling font-st">Container:</Label>
                                </Col> : ""}
                                {item.TipoAgendId == 286 ?  <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                    <Label className="card-Item-alling">{ item.LstCntrs}</Label>
                                </Col> : ""}
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                    <Label className="card-Item-alling font-st">Situação</Label>
                                </Col>
                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                    <Label className="card-Item-alling">{ this.situacaoFormatter(item.StatusAgendamento)}</Label>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>)
            })

       
        ) 
    } 
}



// WEBPACK FOOTER //
// ./src/modules/consultas/triagem-depot/components/cardInformacaoDados.js